
<div v-if="hasError" class="ui warning message">{{ message }}</div>
